// extracted by mini-css-extract-plugin
export var footer = "_ou-5";
export var fulfillmentInput = "_ou-0";
export var shipDateInput = "_ou-1";
export var shipmentModal = "_ou-2";
export var shipmentModalContent = "_ou-3";
export var tableContainer = "_ou-4";